import api from '../config/api';

function fail(error, fallback) {
  return {
    success: false,
    error: error.response?.data?.error || fallback,
    details: error.response?.data?.details,
  };
}

const construccionCivilService = {
  async contexto(empresaId) {
    try {
      return (await api.get(`/construccion-civil/empresa/${empresaId}/contexto`)).data;
    } catch (e) {
      return fail(e, 'Error al cargar contexto de construcción civil');
    }
  },
  async fichas(empresaId) {
    try {
      return (await api.get(`/construccion-civil/empresa/${empresaId}/fichas`)).data;
    } catch (e) {
      return fail(e, 'Error al cargar fichas CONSU');
    }
  },
  async guardarObra(empresaId, payload) {
    try {
      return (await api.post(`/construccion-civil/empresa/${empresaId}/obras`, payload)).data;
    } catch (e) {
      return fail(e, 'Error al guardar la obra');
    }
  },
  async actualizarObra(empresaId, id, payload) {
    try {
      return (await api.put(`/construccion-civil/empresa/${empresaId}/obras/${id}`, payload)).data;
    } catch (e) {
      return fail(e, 'Error al actualizar la obra');
    }
  },
  async parametrosGlobales() {
    try {
      return (await api.get('/construccion-civil/parametros')).data;
    } catch (e) {
      return fail(e, 'Error al cargar parámetros de construcción civil');
    }
  },
  async guardarParametroGlobal(payload) {
    try {
      return (await api.post('/construccion-civil/parametros', payload)).data;
    } catch (e) {
      return fail(e, 'Error al guardar el parámetro');
    }
  },
  async guardarParametro(empresaId, payload) {
    try {
      return (await api.post(`/construccion-civil/empresa/${empresaId}/parametros`, payload)).data;
    } catch (e) {
      return fail(e, 'Error al guardar el parámetro');
    }
  },
  async guardarEspecialidad(empresaId, payload) {
    try {
      return (await api.post(`/construccion-civil/empresa/${empresaId}/especialidades`, payload)).data;
    } catch (e) {
      return fail(e, 'Error al guardar la especialidad');
    }
  },
  async ficha(empresaId, empleadoId) {
    try {
      return (await api.get(`/construccion-civil/empresa/${empresaId}/empleados/${empleadoId}`)).data;
    } catch (e) {
      return fail(e, 'Error al cargar ficha CONSU');
    }
  },
  async guardarFicha(empresaId, empleadoId, payload) {
    try {
      return (await api.put(`/construccion-civil/empresa/${empresaId}/empleados/${empleadoId}`, payload)).data;
    } catch (e) {
      return fail(e, 'Error al guardar ficha CONSU');
    }
  },
  async guardarHijo(empresaId, empleadoId, formData) {
    try {
      return (await api.post(`/construccion-civil/empresa/${empresaId}/empleados/${empleadoId}/hijos`, formData)).data;
    } catch (e) {
      return fail(e, 'Error al registrar hijo');
    }
  },
  async eliminarHijo(empresaId, empleadoId, hijoId) {
    try {
      return (await api.delete(`/construccion-civil/empresa/${empresaId}/empleados/${empleadoId}/hijos/${hijoId}`)).data;
    } catch (e) {
      return fail(e, 'Error al eliminar hijo');
    }
  },
  async registrarDerechos(empresaId, items) {
    try {
      return (await api.post(`/construccion-civil/empresa/${empresaId}/derechos`, { items })).data;
    } catch (e) {
      return fail(e, 'Error al registrar derechos');
    }
  },
  async conciliacion(empresaId, anio, mes) {
    try {
      return (await api.get(`/construccion-civil/empresa/${empresaId}/conciliacion`, { params: { anio, mes } })).data;
    } catch (e) {
      return fail(e, 'Error al conciliar el mes');
    }
  },
  async liquidarCese(empresaId, empleadoId, fechaCese) {
    try {
      return (await api.get(`/construccion-civil/empresa/${empresaId}/empleados/${empleadoId}/liquidacion`, {
        params: { fecha_cese: fechaCese },
      })).data;
    } catch (e) {
      return fail(e, 'Error al liquidar CONSU');
    }
  },
  async auditoria(empresaId) {
    try {
      return (await api.get(`/construccion-civil/empresa/${empresaId}/auditoria`)).data;
    } catch (e) {
      return fail(e, 'Error al cargar auditoría');
    }
  },
};

export default construccionCivilService;
